function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgInformatica = function SvgInformatica(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Informatica_svg__clip0_4865_3)",
    stroke: "#1A1D23",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.42 14.13V4.896c0-.781-.632-1.42-1.404-1.42H4.984c-.773 0-1.404.639-1.404 1.42v9.234H20.43h-.01zM22.407 18.523c.31.714 0 1.553-.716 1.877a1.482 1.482 0 01-.575.124H2.874a1.415 1.415 0 01-1.403-1.42c0-.2.038-.39.122-.581L3.58 14.13H20.43l1.987 4.393h-.01zM10.597 17.684h2.806"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Informatica_svg__clip0_4865_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 3)",
    d: "M0 0h22v18H0z"
  }))));
};
SvgInformatica.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgInformatica.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgInformatica;